import { EMPLOYEE_DETAILS_ACTIONS } from 'Actions/index';
import { BULK_UPLOAD_STATUS } from 'Utils/constants';

const initialState = {
  status: BULK_UPLOAD_STATUS.UPLOAD,
  totalRecords: 0,
  validRecords: 0,
  failedRecords: 0,
  failedRecordsFile: '',
};

const { SET_BULK_UPLOAD_STATUS } = EMPLOYEE_DETAILS_ACTIONS;

const bulkUploadDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_BULK_UPLOAD_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default bulkUploadDetails;
